export default "/assets/images/mila-valentine.png?7ebad58caf36f36c6b8bc751aa292124";